module.exports = "<svg id=\"__1Dm1det__69037c50-83ee-45fb-99d1-318e40b9ec58\" data-name=\"Ebene 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><title>donauhof</title><path d=\"M33,27H3V6.58H33Zm2.5,0H.5v2.5h35ZM18,18.5a.5.5,0,1,0,.5.5A.5.5,0,0,0,18,18.5Zm4.6-4.09a6.48,6.48,0,0,0-4.46-1.9h-.28a6.48,6.48,0,0,0-4.46,1.9m7.78,1.41a4.5,4.5,0,0,0-6.37,0m5,1.41a2.5,2.5,0,0,0-3.54,0\" style=\"fill:none;stroke:#da9533;stroke-miterlimit:10\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/donauhof-co-working.svg
// module id = 403
// module chunks = 1